export const crmKeys = {
  dealer_for_customer: () => ['DEALER_FOR_CUSTOMER'],
};
